<template>
  <div class="mapcontainer">
    <div id="box">
      <div id="map"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-gl'

export default {
  name: 'ThreeDMapView',
  data() {
    return {
      chart: null
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768
    },
    scatterData() {
      return [
        {
          name: '东南亚',
          value: [115.0, 5.0, 0]
        },
        {
          name: '非洲',
          value: [20.0, 0.0, 0]
        },
        {
          name: '南美洲',
          value: [-60.0, -15.0, 0]
        },
        {
          name: '欧洲',
          value: [10.0, 50.0, 0]
        },

      ]
    }
  },
  mounted() {
    this.initChart()
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    initChart() {
      const dom = document.getElementById('map')
      this.chart = echarts.init(dom)
      const option = {
        backgroundColor: '#1a1a1a',
        globe: {
          show: true,
          // baseTexture: 'https://img.isqqw.com/profile/upload/2024/11/12/ad005ff4-0851-4d13-a36e-cdd9f5382d3b.jpg',
          // baseTexture: '/imgs/home/images/3ddiqiu2.png',
          baseTexture: 'https://oss.echinahealth.cn/3ddiqiu2.png',
          shading: 'color',
          environment: '#edf0f7',
          postEffect: {
            enable: false
          },
          light: {
            main: {
              intensity: 1
            },
            ambient: {
              intensity: 0.8
            }
          },
          viewControl: {
            autoRotate: true,
            autoRotateSpeed: 1,
            distance: this.isMobile ? 150 : 200,
            minDistance: 50,
            maxDistance: 400,
            rotateSensitivity: 1,
            zoomSensitivity: 1
          }
        },
        series: [
          {
            type: 'scatter3D',
            coordinateSystem: 'globe',
            zlevel: 30,
            depthTest: false,
            symbol: 'circle',
            symbolSize: this.isMobile ? 12 : 16,
            itemStyle: {
              color: '#ff8a00',
              borderColor: '#fff',
              borderWidth: 5
            },
            label: {
              show: true,
              formatter: '{b}',
              position: 'bottom',
              zlevel: 31,
              textStyle: {
                color: '#fff',
                fontSize: this.isMobile ? 12 : 16,
                backgroundColor: '#ff8a00',
                borderRadius:25,
                padding: [6,20],
                distance: 0
              }
            },
            emphasis: {
              itemStyle: {
                color: '#ffd93d'
              },
              label: {
                show: true,
                formatter: '{b}',
                position: 'top',
                zlevel: 31,
                textStyle: {
                  color: '#fff',
                  fontSize: this.isMobile ? 12 : 16,
                  backgroundColor: '#336fff',
                  borderRadius: 25,
                  padding: [6, 20],
                  distance: 0
                }
              }
            },
            data: this.scatterData.filter(item => item.name !== '欧洲')
          },
          {
            type: 'scatter3D',
            coordinateSystem: 'globe',
            zlevel: 30,
            depthTest: false,
            symbol: 'circle',
            symbolSize: this.isMobile ? 12 : 16,
            itemStyle: {
              color: '#ff8a00',
              borderColor: '#fff',
              borderWidth: 5
            },
            label: {
              show: true,
              formatter: '{b}',
              position: 'top',
              zlevel: 31,
              textStyle: {
                color: '#fff',
                fontSize: this.isMobile ? 12 : 16,
                backgroundColor: '#ff8a00',
                borderRadius:25,
                padding: [6,20],
                distance: 0
              }
            },
            emphasis: {
              itemStyle: {
                color: '#ffd93d'
              },
              label: {
                show: true,
                formatter: '{b}',
                position: 'top',
                zlevel: 31,
                textStyle: {
                  color: '#fff',
                  fontSize: this.isMobile ? 12 : 16,
                  backgroundColor: '#336fff',
                  borderRadius: 25,
                  padding: [6, 20],
                  distance: 0
                }
              }
            },
            data: this.scatterData.filter(item => item.name === '欧洲')
          }
        ]
      }

      this.chart.setOption(option)
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },

  }
}
</script>

<style scoped>
.mapcontainer {
  max-width: 100vw;
  max-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

#box {
  width: 100%;
  aspect-ratio: 1 / 1;
  width: 740px;
  height: 740px;
}

#map {
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  #box {
    max-width: 90vw;
    max-height: 90vw;
  }
}
</style>